export const SENTRY_RELEASE: string | undefined = '86c34767c3cf5f0617beedcf93158d667492ab6d';
